import { Col } from "react-bootstrap";
import { useFormikContext } from "formik";

import SelectField from "../selectField/SelectField";
import SelectFieldCity from "../selectField/SelectFieldCity";
import SelectFieldState from "../selectField/SelectFieldState";
import InputTextField from "../inputTextField/InputTextField";
import { countryConstants } from "../../../constants";
import {
  getCountryAddressConfig,
  getCountryDefaultCurrency,
  getStateOptions,
} from "../../utility";

//-------Country, currency and address fields of a store, the labels and options depend on the country
const StoreAddressFields = ({
  isShowCurrency = true,
  isDisableCountryCurrency = false,
}) => {
  const { values, initialValues, setFieldValue } = useFormikContext();
  const addressConfig = getCountryAddressConfig(values.countryCode);

  //-------Address fields depend on the country so reset them when the country changes
  const handleCountryChange = (countryCode) => {
    if (isShowCurrency && countryCode !== values.countryCode) {
      setFieldValue("currency", getCountryDefaultCurrency(countryCode));
    }
  };

  return (
    <>
      <Col md={6} className="mb-3">
        <InputTextField
          name="line1"
          type="address"
          placeHolder="Enter Address"
          label={addressConfig.line1Label}
        />
      </Col>
      <Col md={6} className="mb-3">
        <InputTextField
          name="line2"
          type="address"
          placeHolder="Enter Address Line 2"
          label={addressConfig.line2Label}
        />
      </Col>
      <Col md={6} className="mb-3">
        <SelectFieldCity
          cityValue={
            values.city ? { value: values.city, label: values.city } : ""
          }
          countryCodes={[values.countryCode]}
          defaultValue={initialValues.city}
          label={addressConfig.cityLabel}
        />
      </Col>
      <Col md={6} className="mb-3">
        <SelectFieldState
          options={getStateOptions(values.countryCode)}
          label={addressConfig.stateLabel}
          placeHolder={addressConfig.statePlaceHolder}
        />
      </Col>
      <Col md={6} className="mb-3">
        <InputTextField
          name="zip"
          placeHolder={addressConfig.zipPlaceHolder}
          label={addressConfig.zipLabel}
        />
      </Col>
      <Col md={6} className="mb-3">
        <SelectField
          label="Country"
          name="countryCode"
          placeHolder={"Select Country"}
          options={countryConstants.COUNTRY_OPTIONS}
          isSearchable={false}
          onChangeValue={handleCountryChange}
          isDisabled={isDisableCountryCurrency}
        />
      </Col>
      {isShowCurrency && (
        <Col md={6} className="mb-3">
          <SelectField
            label="Currency"
            name="currency"
            placeHolder={"Select Currency"}
            options={countryConstants.CURRENCY_OPTIONS}
            isSearchable={false}
            isDisabled={isDisableCountryCurrency}
          />
        </Col>
      )}
    </>
  );
};

export default StoreAddressFields;
